export default "__VITE_ASSET__97f1c053__"